// Google Analytics 4 (gtag.js) loader. Idempotent: calling load() twice is safe.
// Only invoked after the user has granted consent.

const DEFAULT_GA4_ID = 'G-GT2VKJ3NG3'
const SCRIPT_ATTR = 'data-helin-ga'

interface GtagWindow extends Window {
  dataLayer?: Array<unknown>
  gtag?: (...args: unknown[]) => void
}

export function getGa4Id(): string {
  const fromEnv = (import.meta.env.VITE_GA4_ID as string | undefined)?.trim()
  return fromEnv && fromEnv.length > 0 ? fromEnv : DEFAULT_GA4_ID
}

export function isGa4Loaded(): boolean {
  return document.querySelector(`script[${SCRIPT_ATTR}]`) !== null
}

export function loadGa4(id: string = getGa4Id()): void {
  if (isGa4Loaded()) return
  if (!id) return

  const w = window as GtagWindow
  w.dataLayer = w.dataLayer ?? []
  // gtag forwards every call as an arguments-list push onto dataLayer; this
  // matches the snippet Google ships and is what GA expects.
  w.gtag =
    w.gtag ??
    function gtag() {
      // eslint-disable-next-line prefer-rest-params
      w.dataLayer!.push(arguments)
    }
  w.gtag('js', new Date())
  w.gtag('config', id)

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`
  script.setAttribute(SCRIPT_ATTR, id)
  document.head.appendChild(script)
}
